import React from 'react';
import { inject, observer } from 'mobx-react';
import { Field, renderField, renderToggle } from '../../../../utils/formFieldHelper';
import Form from '../../../Settings/Form/Form';
import Section from '../../../Section/Section';
import { StoresEnum } from '../../../../stores';

// Clamped on the way in rather than validated: a bad value would only block the form's own Update.
const parseRolloutPercent = value => {
  // '' is kept as-is so the field can be cleared while typing; the SDK reads an empty percent as off.
  if (value === '') return undefined;

  // Whole percentages only, and anything unparsable (NaN) falls back to 0.
  const percent = Math.round(Number(value)) || 0;

  // Out of range sticks to the closest bound: -5 -> 0, 150 -> 100.
  return Math.min(Math.max(percent, 0), 100);
};

// Written whole rather than merged, so the dead `active` flag drops out of older documents.
export const buildHumanPayload = values => {
  const { enabled, rolloutPercent } = values.campaignSettings?.tools?.human || {};
  return {
    ...values,
    campaignSettings: {
      ...values.campaignSettings,
      tools: {
        ...values.campaignSettings?.tools,
        human: {
          enabled: Boolean(enabled),
          rolloutPercent: parseRolloutPercent(rolloutPercent) || 0,
        },
      },
    },
  };
};

const HumanSettingsForm = ({ channelStore: { channel, readOnly, updateChannel } }) => {
  const onSubmit = values => updateChannel(buildHumanPayload(values));

  const renderFields = () => (
    <>
      <Field
        name="campaignSettings.tools.human.enabled"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly}
        label="Enable HUMAN malvertising tool"
      />
      <Field
        name="campaignSettings.tools.human.rolloutPercent"
        type="number"
        min="0"
        max="100"
        step="1"
        component={renderField}
        readOnly={readOnly}
        label="HUMAN gradual rollout % (0 or empty = off)"
        parse={parseRolloutPercent}
      />
    </>
  );

  return (
    <Section title="HUMAN MALVERTISING">
      <Form
        initialValues={channel}
        fields={renderFields()}
        onSubmit={onSubmit}
        hideCancelButton
        hideApproveButton={readOnly}
      />
    </Section>
  );
};

export default inject(StoresEnum.CHANNEL)(observer(HumanSettingsForm));
